export const structuredDataJob = (job) => {
    const linkServer = 'https://www.m-profiler.com';
    let logoLink = "";
    let logoPath = "/images/logo-Match-Profiler-Google-Jobs.png";
    logoLink = navigator.userAgent !== 'ReactSnap' ? window.location.origin + logoPath : linkServer + logoPath;
    let data = {
        "@context": "http://schema.org/",
        "@type": "JobPosting",
        "datePosted": job.publishedDate,
        "hiringOrganization": {
            "@type": "Organization",
            "name": "Match Profiler",
            "sameAs": "https://www.m-profiler.com/",
            "logo": logoLink
        },
        "directApply": "True",
        "title": job.jobTitle,
        "description": job.functionDescription.replace(/<[^>]+>/g, "").replace(/(\r\n\r\n\r\n)/gm, ""),
        "jobLocation": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": job.location
            }
        }
    };

    return JSON.stringify(data);
};